<template>
    <a class="back-button" role="button" :title="title || $t('Back')" @click="goBack(to, entry)">
        <b-icon :icon="icon" :size="size"></b-icon>
        <span v-if="$slots.default || label" class="back-button__label">
            <slot>{{ label }}</slot>
        </span>
    </a>
</template>

<script setup>
import { useGoBack } from '@/composables/useGoBack';

/**
 * The house back arrow: it returns to the screen the user came from
 * (`history.back()`), and only uses `to` when there is no history — a link
 * opened in a new tab, a bookmark, a link from an email.
 *
 * `to` is therefore a fallback, not a destination: give it the page this one
 * sits under. Styling stays with the caller, which passes its own classes
 * (`button`, `button is-text`, `navbar-item`, …) as on any element.
 */
defineProps({
    to: { type: [Object, String], default: null },
    // Where a record was entered ({position, hadBack}): the arrow then leaves
    // the record instead of stepping back one of its tabs — see resolveLeave().
    entry: { type: Object, default: null },
    label: { type: String, default: '' },
    title: { type: String, default: '' },
    icon: { type: String, default: 'chevron-left' },
    size: { type: String, default: 'is-small' }
});

const goBack = useGoBack();
</script>

<style scoped>
.back-button {
    cursor: pointer;
}

.back-button__label {
    margin-left: 0.25rem;
}
</style>
